import React, { useEffect, useState } from 'react'
import PageHeading from '../../components/PageHeading'

// Master APIs
import GetDepartmentMaster from '../../APIs/Master/DepartmentMaster/GetDepartmentMaster'
import GetDesignationMaster from '../../APIs/Master/DesignationMaster/GetDesignationMaster'
import GetRoleMaster from '../../APIs/Master/RoleMaster/GetRoleMaster'
import GetUserType from '../../APIs/Master/UserTypeMaster/UserTypeMaster'
import SignUpApi from '../../APIs/SignUp/SignUpApi'
import GetUsers from '../../APIs/User/GetUsers'
import GetAllClientId from '../../APIs/Master/ClientMaster/Getallclients'
import InsertClientdata from '../../APIs/Master/ClientMaster/InsertClientdata'

export const ClientMasterList = () => {

    const clientId = window.clientId;

    const [roleList, setRoleList] = useState([])
    const [userTypeList, setUserTypeList] = useState([])
    const [designationList, setDesignationList] = useState([])
    const [departmentList, setDepartmentList] = useState([])
    const [userList, setuserList] = useState([])

    const [sendForm, setSendForm] = useState({
        name: "",
        mobileNo: "",
        userId: window.userId,
        clientId: window.userId,
        handlingby: ""
    })

    // Date Filter State
    const [filterData, setFilterData] = useState({
        fromDate: "",
        toDate: ""
    })

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target

        let updatedvalue = value

        // Allow only numbers in mobile number field
        if (name === "mobileNo") {
            updatedvalue = updatedvalue.replace(/\D/g, "")
        }

        setSendForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : updatedvalue
        }))
    }

    // Date Filter Change
    const handleFilterChange = (e) => {
        const { name, value } = e.target

        setFilterData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    // Get Client Data
    const getclientdata = async () => {

        const data = await GetAllClientId(
            clientId,
            filterData.fromDate,
            filterData.toDate
        )

        setuserList(data?.responseValue || [])
    }

    // Search Button
    const handleSearch = () => {
        getclientdata()
    }

    // Reset Button
    const handleReset = async () => {

        setFilterData({
            fromDate: "",
            toDate: ""
        })

        const data = await GetAllClientId(clientId, "", "")
        setuserList(data?.responseValue || [])
    }

    useEffect(() => {
        getclientdata()
    }, [])

    return (
        <div className='row'>

            <PageHeading pagename="Client Data List" />

            {/* Filters */}
            <div className="row pt-3 align-items-end">

                <div className="col-md-3">
                    <label>From Date</label>
                    <input
                        type="date"
                        className="form-control"
                        name="fromDate"
                        value={filterData.fromDate}
                        onChange={handleFilterChange}
                    />
                </div>

                <div className="col-md-3">
                    <label>To Date</label>
                    <input
                        type="date"
                        className="form-control"
                        name="toDate"
                        value={filterData.toDate}
                        onChange={handleFilterChange}
                    />
                </div>

                <div className="col-md-3 d-flex gap-2">
                    <button
                        className="btn btn-primary"
                        onClick={handleSearch}
                    >
                        Search
                    </button>

                    <button
                        className="btn btn-secondary"
                        onClick={handleReset}
                    >
                        Reset
                    </button>
                </div>

            </div>

            {/* Table */}
            <div className="pt-4">

                <table className="table">

                    <thead>
                        <tr className="table-head">
                            <th>Sno.</th>
                            <th>Name</th>
                            <th>Phone Number</th>
                            <th>Handling By</th>
                        </tr>
                    </thead>

                    <tbody style={{ width: "100%" }}>

                        {userList && userList?.length > 0 ? (
                           userList && userList?.map((val, ind) => {

                                return (
                                    <tr key={ind}>

                                        <td>
                                            {ind + 1}
                                        </td>

                                        <td>
                                            {val.name}
                                        </td>

                                        <td>
                                            {val.phoneNumber}
                                        </td>

                                        <td>
                                            {val.handlingbyempId}
                                        </td>

                                    </tr>
                                )
                            })
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No Data Found
                                </td>
                            </tr>
                        )}

                    </tbody>

                </table>

            </div>

        </div>
    )
}